"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _colors = require("HubStyleTokens/colors");

var _isValidI18nKey = _interopRequireDefault(require("I18n/utils/isValidI18nKey"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIconHolder = _interopRequireDefault(require("UIComponents/icon/UIIconHolder"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIExpandableText = _interopRequireDefault(require("UIComponents/text/UIExpandableText"));

var ScopeGroup = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/scopes/ScopeGroup"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _withTranslations = _interopRequireDefault(require("../../../decorators/withTranslations"));

var _en = _interopRequireDefault(require("i2l?query=sporks!ecosystem-marketplace-core/lang/scopes/en.lyaml"));

var getScopeGroupIconName = (0, _memoize.default)(function (scopeGroup) {
  switch (scopeGroup) {
    case ScopeGroup.ACTIONS:
      return 'contactProperties';

    case ScopeGroup.AUTOMATION:
      return 'workflows';

    case ScopeGroup.BUSINESS_INTELLIGENCE:
      return 'case';

    case ScopeGroup.CONTACTS:
      return 'contacts';

    case ScopeGroup.CONTENT:
      return 'blog';

    case ScopeGroup.E_COMMERCE:
      return 'cart';

    case ScopeGroup.FILES:
      return 'file';

    case ScopeGroup.FORMS:
      return 'forms';

    case ScopeGroup.HUBDB:
      return 'hubDB';

    case ScopeGroup.INTEGRATION_SYNC:
      return 'integrations';

    case ScopeGroup.LISTS:
      return 'lists';

    case ScopeGroup.OAUTH:
      return 'locked';

    case ScopeGroup.REPORTS:
      return 'generateChart';

    case ScopeGroup.SOCIAL:
      return 'social';

    case ScopeGroup.TICKETS:
      return 'ticket';

    case ScopeGroup.TIMELINE:
      return 'time';

    case ScopeGroup.TRANSACTIONAL_EMAIL:
      return 'email';

    default:
      return 'blank';
  }
});

var ScopeGroupIcon = function ScopeGroupIcon(_ref) {
  var scopeGroup = _ref.scopeGroup;
  return _react.default.createElement(_UIIconHolder.default, {
    name: getScopeGroupIconName(scopeGroup),
    backgroundColor: _colors.LORAX_LIGHT,
    borderRadius: "2px",
    color: _colors.LORAX,
    padding: 0.35,
    size: 20
  });
};

var PermissionsList = function PermissionsList(_ref2) {
  var requiredScopeGroups = _ref2.requiredScopeGroups;
  var renderedScopeGroups = (0, _react.useMemo)(function () {
    if (!requiredScopeGroups.size) {
      return null;
    }

    return requiredScopeGroups.map(function (scopeGroup) {
      if (!(0, _isValidI18nKey.default)((0, _i18n.getScopeGroupI18nKey)(scopeGroup))) {
        return null;
      }

      return _react.default.createElement(_UIMediaObject.default, {
        key: scopeGroup,
        itemLeft: _react.default.createElement(ScopeGroupIcon, {
          scopeGroup: scopeGroup
        })
      }, _react.default.createElement("div", {
        className: "is--heading-7 m-bottom-1"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _i18n.getScopeGroupI18nKey)(scopeGroup, 'label')
      })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _i18n.getScopeGroupI18nKey)(scopeGroup, 'description')
      })));
    }).toArray();
  }, [requiredScopeGroups]);
  return _react.default.createElement(_UIExpandableText.default, {
    buttonAlign: "left",
    hideButtonCaret: true,
    maxHeight: 310
  }, _react.default.createElement(_UIList.default, null, renderedScopeGroups));
};

PermissionsList.propTypes = {
  requiredScopeGroups: _reactImmutableProptypes.default.iterableOf(_propTypes.default.oneOf(Object.values(ScopeGroup))).isRequired
};

var _default = (0, _withTranslations.default)([_en.default])(PermissionsList);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/permissions/PermissionsList.js
// module id = 835
// module chunks = 209 210 211 212